import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { range } from '@udemy/shared-utils';
import { useUDData } from '@udemy/ud-data';
import { useHeaderStore } from '../../hooks/use-header-store';
import { useMobileNavStore } from '../../hooks/use-mobile-nav-store';
import { useUfbModels } from '../../hooks/use-ufb-models';
import { MobileNavSectionHeading, MobileNavSection, MobileNavItem } from '../../mobile/mobile-nav/mobile-nav.react-component';
export const BrowseSection = observer(() => {
  var _headerStore$userSpec;
  const udData = useUDData();
  const udConfig = udData.Config;
  const {
    gettext
  } = useI18n();
  const headerStore = useHeaderStore();
  const mobileNavStore = useMobileNavStore();
  const {
    customCategoriesModel,
    learningPathsMenuModel
  } = useUfbModels();
  const isUBUser = udData.me.is_authenticated && !!udData.me.organization;
  const isPPUser = (_headerStore$userSpec = headerStore.userSpecificContext.user) === null || _headerStore$userSpec === void 0 ? void 0 : _headerStore$userSpec.consumer_subscription_active;
  const isTPUser = isUBUser && udConfig.brand.is_team;
  function showCategoryNavigationMenuForUB() {
    const {
      user
    } = headerStore.userSpecificContext;
    return user === null || user === void 0 ? void 0 : user.show_category_navigation_for_ub_users;
  }
  function showBadgingNavChangesForPPUB() {
    const {
      user
    } = headerStore.userSpecificContext;
    return user === null || user === void 0 ? void 0 : user.show_updated_pp_and_ub_navigation;
  }
  function renderCategories() {
    if ((isUBUser || isPPUser || isTPUser) && !showCategoryNavigationMenuForUB()) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, showBadgingNavChangesForPPUB() ? gettext('Explore by category') : gettext('All categories')), /*#__PURE__*/React.createElement(MobileNavSection, null, mobileNavStore.navigationCategories ? mobileNavStore.navigationCategories.map(c => /*#__PURE__*/React.createElement(MobileNavItem, {
      key: c.id,
      cssToggleId: `header-toggle-side-nav-subcategories-of-${c.id}`,
      "data-purpose": "category-item"
    }, c.title)) : range(13).map(i => /*#__PURE__*/React.createElement(MobileNavItem, {
      key: i,
      loading: true
    }))));
  }
  const learningPathsLink = !udConfig.features.organization.learning_path.enabled ? null : /*#__PURE__*/React.createElement(MobileNavItem, {
    cssToggleId: "header-toggle-side-nav-learning-path-folders"
  }, learningPathsMenuModel.title);
  const hasCustomCategories = customCategoriesModel.children.length > 0;
  const customCategoriesLink = !hasCustomCategories ? null : /*#__PURE__*/React.createElement(MobileNavItem, {
    cssToggleId: "header-toggle-side-nav-custom-categories"
  }, customCategoriesModel.title);
  if (!learningPathsLink && !customCategoriesLink) {
    return renderCategories();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, gettext('My organization')), /*#__PURE__*/React.createElement(MobileNavSection, null, learningPathsLink, customCategoriesLink), renderCategories());
});
//# sourceMappingURL=browse-section.react-component.js.map